import { Action, Subject } from '@erp/authz';
import { useCan } from '@/hooks/useCan';

/** Whether the current user may file feedback for someone else (Feedback:Update). */
export function useCanReportOnBehalf(): boolean {
  const [canTriage] = useCan(Action.Update, Subject.Feedback);
  return canTriage;
}
